import * as Yup from "yup";

/***************************************************************
 * 企業新規追加
 **************************************************************/
/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  companyNameIsNull: "企業名を入力してください。",
  locationIsNull: "所在地を入力してください。",
  companyUrlIsNull: "企業のURLを入力してください。"
};

/**
 * バリデーションルール
 */
export const CompanyCreateFormSchema = Yup.object({
  companyName: Yup.string().required(ERR_MESSAGE.companyNameIsNull),
  location: Yup.string().required(ERR_MESSAGE.locationIsNull),
  companyUrl: Yup.string().required(ERR_MESSAGE.companyUrlIsNull),
});
export const CompanyEditFormSchema = Yup.object({
  companyName: Yup.string().required(ERR_MESSAGE.companyNameIsNull),
  location: Yup.string().required(ERR_MESSAGE.locationIsNull),
  companyUrl: Yup.string().required(ERR_MESSAGE.companyUrlIsNull),
});
/**
 * 企業新規作成・編集フォーム(入力チェック用)
 */
export class CompanyEditForm {
  /** 企業ID */
  public companyId: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 所在地 */
  public location: string = "";
  /** 代表者名 */
  public representativeName: string = "";
  /** 企業URL */
  public companyUrl: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
}
// 新規追加用 リクエスト
export class CompanyCreateRequest {
  createdata: CompanyEditForm = new CompanyEditForm();
}
// 編集用 リクエスト
export class CompanyEditRequest {
  editdata: CompanyEditForm = new CompanyEditForm();
}

/***************************************************************
 * 企業詳細
 **************************************************************/
/**
 * 企業詳細取得API リクエスト
 */
export class CompanyDetailRequest {
  /** 企業ID */
  public id: string = "";
}

/**
 * 企業詳細取得API レスポンス
 */
export class CompanyDetailResponse {
  /** 企業ID */
  public id: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 所在地 */
  public location: string = "";
  /** 代表者名 */
  public representativeName: string = "";
  /** 企業URL */
  public companyUrl: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
}

/***************************************************************
 * 他箇所との連携用
 **************************************************************/
/**
 * テナント情報（ID、会社名）取得API リクエスト
 */
export class CompanyNameRequest {
  /** テナントID */
  public id: string = "";
}
/**
 * テナント情報（ID、会社名）取得API レスポンス
 */
export class CompanyNameResponse {
  /** テナントID */
  public id: string = "";
  /** 会社名 */
  public companyName: string = "";
}